
<template>
  <div class="chat-history">
    <!-- <v-container fluid> -->
    <v-flex>
      <v-tabs icons-and-text fixed-tabs grow v-model="activetab">
        <v-tab href="#tab-1">
          Recent
          <v-icon>chat</v-icon>
        </v-tab>
        <v-tab href="#tab-2">
          Contacts
          <v-icon>contacts</v-icon>
        </v-tab>
      </v-tabs>
    </v-flex>
    <v-tabs-items v-model="activetab">
      <v-tab-item value="tab-1">
        <v-subheader center>
          Recent chats
          <v-spacer></v-spacer>
          <v-layout row justify-center>
            <v-dialog v-model="dialog" scrollable max-width="300px">
              <template v-slot:activator="{ on }">
                <!-- <v-spacer></v-spacer> -->
                <v-tooltip bottom>
                  <v-btn icon slot="activator" @click="selected=[]" right v-on="on">
                    <v-icon size="28px">group_add</v-icon>
                  </v-btn>
                  <span>Create group</span>
                </v-tooltip>
              </template>
              <v-card>
                <v-card-title
                  class="headline dialogheader"
                  style="background-color: rgb(207, 216, 220);color:black;"
                >Create group</v-card-title>
                <!-- <v-flex>
                            <v-text-field label="Search user" v-model="search" single-line solo clearable></v-text-field>
                </v-flex>-->
                <!-- <v-divider></v-divider> -->
                <v-card-text style="height: 300px;">
                  <v-list-tile v-for="item in fbstore.ContactList" :key="item.id" avatar>
                    <v-checkbox v-model="selected" :label="item.labelName" :value="item"></v-checkbox>
                  </v-list-tile>

                  <!-- <v-checkbox v-model="selected" label="Jacob" value="Jacob"></v-checkbox> -->
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-btn
                    :color="(selected.length == 0 && isActive)?'':'primary'"
                    @click="startChatGroup"
                    :disabled="selected.length == 0 && isActive"
                  >Create</v-btn>
                  <v-btn @click="dialog = false" color="error">Close</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-layout>
        </v-subheader>
        <template>
          <vue-perfect-scrollbar class="chat-history--scrollbar">
            <v-list two-line class="chat-history--list">
              <v-list-tile
                class="chat-list"
                avatar
                v-for="item in fbstore.chanList"
                :key="item.id"
                @click="gotoChannel(item.channel_name, item.channel_id,item.active)"
              >
                <v-list-tile-avatar>
                  <!-- <img :src="avatar" > -->
                  <!-- <v-icon size="40px">account_circle</v-icon> -->
                  <v-avatar size="40">
                    <img :src="item.imageUrl?item.imageUrl:'user.jpg'">
                  </v-avatar>
                  <!-- <span v-else class="white--text headline">{{ item.name}}</span> -->
                </v-list-tile-avatar>
                <v-list-tile-content style="padding-right: 30px; !important">
                  <v-list-tile-title
                    style="text-decoration: none !important;"
                  >{{item.other_fullnames}}</v-list-tile-title>
                  <!-- <v-list-tile-sub-title>Some Latest message</v-list-tile-sub-title> -->
                </v-list-tile-content>
                <v-list-tile-action>
                  <!-- <v-badge color="red" overlap >
          <span slot="badge" v-if="item.new_message"></span>
                  </v-badge>-->
                  <v-layout row>
                    <v-tooltip bottom style="padding-right: 15px;!important" v-if="!item.active">
                      <!-- <v-btn icon slot="activator"> -->
                      <v-icon size="20px" slot="activator">volume_off</v-icon>
                      <!-- </v-btn> -->
                      <span>Mute</span>
                    </v-tooltip>
                    <v-badge overlap v-if="item.new_message" color="red">
                      <template v-slot:badge>
                        <span>!</span>
                      </template>
                      <v-icon medium color="grey">message</v-icon>
                    </v-badge>
                  </v-layout>
                  <!-- <v-list-tile-action-text>
                {{ formatChatTime(item.date) }}
                  </v-list-tile-action-text>-->
                  <!-- <v-circle dot small :color="chatStatusColor(item)"></v-circle> -->
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </vue-perfect-scrollbar>
        </template>
      </v-tab-item>
      <v-tab-item value="tab-2">
        <template>
          <vue-perfect-scrollbar class="chat-history--scrollbar">
            <v-list two-line class="chat-history--list">
              <v-list-tile
                class="chat-list"
                v-for="(item,index) in fbstore.ContactList"
                :key="item.id"
                avatar
                @click="startChatContacts(item , index)"
                v-bind:class="{ 'disable-div': index ==   fbstore.currentIndex }"
              >
                <v-list-tile-avatar>
                  <!-- <img :src="avatar"> -->
                  <!-- <v-icon size="40px">account_circle</v-icon> -->
                  <v-avatar size="40">
                    <img :src="item.profile?item.profile:'user.jpg'">
                  </v-avatar>
                  <!-- <span v-else class="white--text headline">{{ item.name}}</span> -->
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>{{item.labelName}}</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <!-- <v-list-tile-action-text>
                {{ formatChatTime(item.date) }}
                  </v-list-tile-action-text>-->
                  <!-- <v-circle dot small :color="chatStatusColor(item)"></v-circle> -->
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </vue-perfect-scrollbar>
        </template>
      </v-tab-item>
    </v-tabs-items>
  </div>
  <!-- </v-container> -->
</template>




<script>
import { fbstore, thisUser } from "../../config/fbstore";
// import Util from '@/util';
import VuePerfectScrollbar from "vue-perfect-scrollbar";
export default {
  name: "ChatList",
  components: {
    VuePerfectScrollbar
  },
  props: {
    msg: String
  },
  data: function() {
    return {
      fbstore,
      search: "",
      channels: fbstore.chanList,
      names: "mylene",
      avatar: "http://cdn.vuetifyjs.com/images/lists/1.jpg",
      currentChannel: "",
      dialogm1: "",
      dialog: false,
      selected: [],
      isActive: true,
      activetab: "tab-1"
    };
  },
  computed: {
    filteredContacts() {
      return _.orderBy(
        fbstore.ContactList.filter(item => {
          if (!this.search) return fbstore.ContactList;
          return item.labelName
            .toLowerCase()
            .includes(this.search.toLowerCase());
        }),
        "labelName"
      );
    }
  },
  methods: {
    // getChannels: () => {},
    startChat(contact) {
      fbstore.startChat(contact);
    },
    startChatContacts(contact, cindex) {
      fbstore.currentIndex = cindex;
      let cons = [];
      cons.push(contact);
      var isGroup = false;
      fbstore.createChannel(cons, isGroup);
      this.activetab = "tab-1";
    },
    startChatGroup() {
      this.isActive = false;
      var isGroup = true;
      fbstore.createChannel(this.selected, isGroup);
      this.dialog = false;
      this.selected = [];
      this.isActive = true;
    },
    gotoChannel(channel, chanId, isMuted) {
      fbstore.gotoChatChannel(channel, chanId, isMuted);
    }
  },
  mounted() {
    // fbstore.getChannels();
    //this.channels = fbstore.chanList;
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
